import styled from 'styled-components'
import { theme, VerticalSpacer } from '@superhi/design'

export const Wrapper = styled(VerticalSpacer).attrs({
  amount: { small: 16, medium: 16, large: 16 },
})`
  background-color: ${theme.colors.YELLOW_20};
  padding: 24px 16px;

  @media ${theme.breakpoints.medium} {
    padding: 24px 40px;
  }

  @media ${theme.breakpoints.large} {
    padding: 24px;
    border-radius: 10px;
  }
`

export const Items = styled(VerticalSpacer).attrs({
  amount: { small: 10, medium: 10, large: 10 },
})`
  > *:not(:last-child) {
    &:after {
      content: '';
      display: block;
      margin: 16px 0;
      height: 1px;
      background-color: ${theme.colors.PINK_50};
    }
  }
`

export const CurrentWrapper = styled.div`
  opacity: 0.5;
  pointer-events: none;
`
